<template>
    <div>
        <div class="col-12 rules_section">
          <div>
            <h3 v-if="language === 'english'">{{english.DealerTutorial.h3_1}}</h3>
            <h3 v-else-if="language === 'spanish'">{{spanish.DealerTutorial.h3_1}}</h3>

            

            <p v-if="language === 'english'">{{english.DealerTutorial.p_1}}</p>
            <p v-else-if="language === 'spanish'">{{spanish.DealerTutorial.p_1}}</p>
            
            <h2 v-if="language === 'english'">{{english.DealerTutorial.h3_2}}</h2>
            <h2 v-else-if="language === 'spanish'">{{spanish.DealerTutorial.h3_2}}</h2>

            <p v-if="language === 'english'">{{english.DealerTutorial.p_2}}</p>
            <p v-else-if="language === 'spanish'">{{spanish.DealerTutorial.p_2}}</p>
            
            <p v-if="language === 'english'">{{english.DealerTutorial.p_3}}</p>
            <p v-else-if="language === 'spanish'">{{spanish.DealerTutorial.p_3}}</p>

            <a v-if="language === 'english'" 
            href="https://www.nba.com/spurs/spurs-loteria-rules" 
            target="_blank">{{english.DealerTutorial.a_1}}</a>
            <a v-else-if="language === 'english'" 
            href="https://www.nba.com/spurs/spurs-loteria-rules" 
            target="_blank">{{spanish.DealerTutorial.a_1}}</a>
          </div>
        </div>
    </div>
</template>

<script>
import english from '../assets/json/languages/english.json'
import spanish from '../assets/json/languages/spanish.json'

export default {
  name: 'DealerTutorialView',
  props: ['language'],
  data(){
    return{
      english, spanish
    }
  }
}
</script>
